export const CLEAR_RESULT_MESSAGE = 'CLEAR_RESULT_MESSAGE'
export const GET_ACTIVE_SHEETS = 'GET_ACTIVE_SHEETS'
export const GET_CONFIGURATION_TYPES = 'GET_CONFIGURATION_TYPES'
export const INITIATE_CONFIGURATION_STEP = 'INITIATE_CONFIGURATION_STEP'
export const TOGGLE_STATUS_OPEN = 'TOGGLE_STATUS_OPEN'
